export default __webpack_public_path__ + "images/KF.ce27976.png";